<div class="notifications-container">
  {{ data }}
</div>
